import { IFieldServer } from "@common/redux/forms/interface";
export const sectionDefaultValue: IFieldServer = {
  title: "New Section",
  description: "",
  name: "field_set",
  isSection: true,
  fieldType: "SECTION",
  element: "fieldset",
  type: "fieldset",
  grid: {
    width: 12,
  },
  fields: [],
  fieldConfig: {
    isPII: false,
    isQrCodeAllowed: false,
  },
};
